import React from 'react';

import JobsUserContainer from './JobsUserContainer';
import FlatManualJobsContainer from './FlatManualJobsContainer';

const FlatManualJobsContainerWrapper = (props) => (
  <JobsUserContainer {...props}>
    <FlatManualJobsContainer />
  </JobsUserContainer>
);

export default FlatManualJobsContainerWrapper;
